import loadable from '@loadable/component';

const LoadableGenericErrorMessage = loadable(
    () => import(/* webpackChunkName: "generic-error-message" */ './component'),
);

export default LoadableGenericErrorMessage;
